/** Sign-in page artwork: the order-to-invoice road past the factory. Decorative only. */

const ROUTE = 'M30 900 C 30 790, 225 770, 200 650 S 25 520, 100 400 S 245 290, 170 160 S 90 40, 160 -10';

// Labels sit on the left of pins near the card edge so the card never covers them.
const STOPS = [
  { x: 55, y: 820, label: 'Order', w: 74, left: false, icon: 'M9 4h6l1 2h3v15H5V6h3zM9 11h6M9 15h4' },
  { x: 200, y: 668, label: 'Plan', w: 66, left: true, icon: 'M4 5h16v15H4zM4 10h16M9 3v4M15 3v4' },
  { x: 85, y: 486, label: 'Produce', w: 92, left: false, icon: 'M3 15V11a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v4M3 15h18v3H3zM6 9V6h12v3' },
  { x: 205, y: 300, label: 'Deliver', w: 86, left: true, icon: 'M2 7h11v9H2zM13 10h4l3 3v3h-7M6 19a2 2 0 1 0 0-.1M17 19a2 2 0 1 0 0-.1' },
  { x: 115, y: 126, label: 'Invoice', w: 86, left: false, icon: 'M6 3h9l3 3v15H6zM9 12h6M9 16h4' },
];

export function LoginArt({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 840 900" preserveAspectRatio="xMinYMid slice" className={className} aria-hidden>
      <defs>
        <linearGradient id="la-bg" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#E9F6EF" /><stop offset="1" stopColor="#D3EDE0" /></linearGradient>
        <linearGradient id="la-sw" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#22A86E" /><stop offset="1" stopColor="#0B3B28" /></linearGradient>
        <linearGradient id="la-road" x1="0" y1="1" x2="0" y2="0"><stop offset="0" stopColor="#FFFFFF" /><stop offset="1" stopColor="#E3F6EC" /></linearGradient>
        <linearGradient id="la-pin" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stopColor="#2DBE7E" /><stop offset="1" stopColor="#0E6A45" /></linearGradient>
        <linearGradient id="la-bld" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stopColor="#FFFFFF" /><stop offset="1" stopColor="#CDE7DA" /></linearGradient>
      </defs>
      <rect width="840" height="900" fill="url(#la-bg)" />
      <path d="M470 0 C 430 170, 560 250, 840 270 L 840 0 Z" fill="url(#la-sw)" />
      <path d="M560 900 C 600 760, 720 720, 840 700 L 840 900 Z" fill="url(#la-sw)" opacity="0.9" />
      <path d="M0 610 C 120 560, 260 600, 360 570 L 360 900 L 0 900 Z" fill="#CBE8D9" />
      <path d="M0 720 C 140 680, 240 720, 380 690 L 380 900 L 0 900 Z" fill="#B9E0CC" />
      <g transform="translate(110 330) scale(0.75)">
        <rect x="0" y="40" width="190" height="120" fill="url(#la-bld)" stroke="#B5DAC7" />
        <path d="M0 40 L 0 10 L 38 40 L 38 10 L 76 40 L 76 10 L 114 40 L 114 10 L 152 40 L 152 10 L 190 40 Z" fill="#E8F5EE" stroke="#B5DAC7" strokeLinejoin="round" />
        <rect x="160" y="-40" width="18" height="70" fill="#E8F5EE" stroke="#B5DAC7" />
        <rect x="18" y="70" width="26" height="20" rx="3" fill="#BFE3D0" />
        <rect x="58" y="70" width="26" height="20" rx="3" fill="#BFE3D0" />
        <rect x="98" y="70" width="26" height="20" rx="3" fill="#BFE3D0" />
        <rect x="140" y="100" width="34" height="60" rx="3" fill="#9FD3B8" />
      </g>
      <path d={ROUTE} fill="none" stroke="#FFFFFF" strokeOpacity="0.65" strokeWidth="88" strokeLinecap="round" />
      <path d={ROUTE} fill="none" stroke="url(#la-road)" strokeWidth="60" strokeLinecap="round" />
      <path d={ROUTE} fill="none" stroke="#8ED3B0" strokeWidth="3" strokeDasharray="12 12" />
      <g fill="#86CDA8">
        <circle cx="30" cy="580" r="26" /><circle cx="54" cy="564" r="20" /><circle cx="250" cy="790" r="24" />
        <circle cx="272" cy="772" r="18" /><circle cx="40" cy="250" r="22" /><circle cx="255" cy="520" r="20" />
      </g>
      <g fill="#5DB98C"><circle cx="42" cy="592" r="16" /><circle cx="262" cy="802" r="14" /><circle cx="50" cy="262" r="13" /></g>
      {STOPS.map((s) => (
        <g key={s.label} transform={`translate(${s.x} ${s.y})`}>
          <ellipse cx="0" cy="4" rx="16" ry="5" fill="#0B3B28" opacity="0.18" />
          <path d="M0 0 C -6 -10, -30 -26, -30 -46 A 30 30 0 1 1 30 -46 C 30 -26, 6 -10, 0 0 Z" fill="url(#la-pin)" />
          <circle cx="0" cy="-46" r="20" fill="#FFFFFF" />
          <g transform="translate(-11 -57) scale(0.92)" fill="none" stroke="#138A5A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d={s.icon} /></g>
          <rect x={s.left ? -38 - s.w : 38} y="-62" width={s.w} height="30" rx="15" fill="#FFFFFF" stroke="#CFE9DC" />
          <text x={s.left ? -24 - s.w : 52} y="-42" fontSize="14" fontWeight="700" fill="#0B3B28" style={{ fontFamily: 'inherit' }}>{s.label}</text>
        </g>
      ))}
    </svg>
  );
}
